import React, {Component, useDebugValue, useSyncExternalStore} from 'react';
import { useState } from "react";
import * as AiIcons from "react-icons/ai";
import { Button, Alert, Modal } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import UserService from './services/user.serviceaux';
import RoleService from './services/role.service';
import { useEffect } from 'react';
import { Form, Container, Row } from 'react-bootstrap';
import { useDispatch, } from "react-redux";
import { resetpsw } from "./actions/auth.js";
import { useSelector } from 'react-redux';


var newDate = new Date();
//var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()
var gtDate = new Date().toLocaleString() + ""; 

function UpdateUser(props) { 
  const [lgShow, setLgShow] = useState(false);
  const [Errmessage, setErrmessage] = useState("");
  const [Showerror, setShowerror] = useState("");
  const [Sucmessage, setSuccmessage] = useState("");
  const [Showsuccess, setShowsuccess] = useState("");
  const [Submitted, setSubmitted] = useState(false);
  const [username,setUsername] = useState('');
  const [email,setEmail] = useState('');
  const [roles,setRoles] = useState([]);
  const [password,setPassword] = useState('');
  const dispatch = useDispatch();

  const [userRoles, setUserRoles] = useState([]);
  // This is how you make the current user available on any functional component
  const { user } = useSelector(state => state.auth);

  const handleClose = () => setLgShow(false);
  const handleShow = () => {
    UserService.get(props.userid)
    .then(response => {
        setSuccmessage('');
        setErrmessage('');
        setShowerror(false);
        setShowsuccess(false);      
        setPassword('');  
        setUsername(response.data[0].username);
        setEmail(response.data[0].email);
        setUserRoles(response.data[0].roles.map ((a) => a.id));
        setLgShow(true);        
      })      
    .catch(e => {
      console.log(e);
    }); 
    
    RoleService.getAll()
    .then(response => {
        setRoles(response.data);
        //console.log(response.data)
    })      
    .catch(e => {
      console.log(e);
    }); 
    
  }

  let handleValidations = () => {
    console.log(userRoles.length);
    if (username.length ==0 || userRoles.length == 0) {      
      setErrmessage('Username, password and roles can not be empty.');
      setShowerror(true);
      return;
    }
    if (email) {
      if (!/\S+@\S+\.\S+/.test(email)) {
        setErrmessage('Email is invalid.');
        setShowerror(true);      
        return;
      }
    }
    saveUser();
  } 

  let onChangeUserName = (e) => {
    setUsername(e.target.value); 
  }  

  let onChangeEmail = (e) => {
    setEmail(e.target.value); 
  } 
  
  let onChangeRoles = (e) => {
    // check if checkbox is checked
    if (e.target.checked === true) {
        // check if user role is already assigned to the user
        if (userRoles.includes(e.target.id)) {
            //console.log(userRoles);
            // Do nothing.
        }
        else {
            setUserRoles([...userRoles, parseInt(e.target.id)])
            //console.log(userRoles);
        }
    }
    else {
        // check if user role is already assigned to the user
        if (userRoles.includes(parseInt(e.target.id))) {
            //console.log(userRoles);
            setUserRoles(
                userRoles.filter(a => a !== parseInt(e.target.id))
            );
        }
        else {
            //console.log('value is' + e.target.value);
            //console.log('id is ' + e.target.id);
            //console.log(userRoles);
            // Do nothing.            
        }
    }
  }   

  let saveUser = ()  =>{   
    var data = {
        username: username,
        email: email,
        roles: userRoles,
    }    
    
    UserService.update(props.userid, data)
    .then(response => {
      console.log(response);
      setSubmitted(true);
      setSuccmessage('User has been updated. Redirecting to user list...');
      setShowsuccess(true);
      setErrmessage('');
      setShowerror(false);        
      window.location.assign('/admin-users');
    })
    .catch(e => {
      console.log(e);
      setErrmessage(e.response?e.response.data.message:e.message);
      setShowerror(true);      
      setSuccmessage('');
      setShowsuccess(false);            
    })        
  }

  let restorePassword = () => {
    var data = {
      userid: props.userid,
      password: Math.random().toString(36).substr(2, 8),
    }    
    dispatch(resetpsw(user.id, data.userid, data.password)) 
    .then(() => {
      setPassword(data.password);
      setShowerror(false);
      setSuccmessage('Password has been reset. Please, share this information with ' + props.username);
      setShowsuccess(true);
    })
    .catch((e) => {
      console.log(e);
      setShowsuccess(false);
      setErrmessage(e.response?e.response.data.message:e.message);
      setShowerror(true);
    });     
  }

    return (
      <>
        <Button variant="link" onClick={handleShow}><AiIcons.AiFillEdit /></Button>      
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => setLgShow(false)}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Update User'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-start flex-wrap">
              <div className="m-1">
                <label className="mr-5" htmlFor="description">User ID:</label>
                <input className="form-control mb-3"
                  type="text"
                  name="userid"
                  disabled
                  id="userid"
                  value={props.userid}/>
              </div>                       
              <div className="m-1">
                <label className="mr-5" htmlFor="description">Username:</label>
                <input className="form-control mb-3"
                  type="text"
                  name="username"
                  id="username"
                  defaultValue={props.username}
                  onChange={onChangeUserName}/>
              </div> 
              <div className="m-1">
                <label className="mr-5" htmlFor="email">Email:</label>
                <input className="form-control mb-3"
                  type="text"
                  name="email"
                  id="email"
                  defaultValue={props.email}
                  onChange={onChangeEmail}/>
              </div>                                             
            </div>
            <div>
                <h5>User Roles</h5>
                {roles.map((row, index) => {  
                    //console.log(userRoles);
                    //var userroleids = userRoles?userRoles.map(function (el) { return el; }):[];
                    return (
                        <Form>
                            <div className='mb-3 sm-0'>
                                <Form.Check 
                                    type={'checkbox'}
                                    id={row.id}
                                    label={row.rolename}
                                    defaultChecked={(userRoles.includes(row.id))?true:false}
                                    onChange={onChangeRoles}
                                />
                            </div>
                        </Form>
                    )
                })}
            </div>
            <div>
              <div className="m-1">
                <label className="mr-5" htmlFor="description">Password:</label>
                <input className="form-control mb-3"
                  type="text"
                  name="password"
                  disabled
                  id="password"
                  value={password}/>
              </div>                
            </div>             
            <hr/>
            <div className="d-flex justify-content-start flex-wrap">      
                <Button className="m-4" onClick={restorePassword}>
                  Reset Password
                </Button>          
                <Button className="m-4" onClick={handleValidations}>
                  Save
                </Button>            
            </div>           
              {Showerror && (
                <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                  <Alert.Heading>Error</Alert.Heading>
                  <p>{Errmessage}</p>
                </Alert>      
              )}
              {Showsuccess && (
                <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                  <Alert.Heading>Done</Alert.Heading>
                  <p>{Sucmessage}</p>
                </Alert>      
              )}     
              {/*{Submitted ? (<Navigate push to="/admin-users"/>) : null }                                                   */}
          </Modal.Body>
        </Modal>
      </>
    );
  }

  
  export default UpdateUser;